import Action from "csi/def/Action";
import AddPath from "csi/def/AddPath";
import Relationship from "csi/def/Relationship";
import ViewRef from "csi/def/ViewRef";
import StoreNamesConstructor, { StoreNames } from "csi/store/Names";
import csiStore from "csi/store/_base";
import New from "csi/table/New";
import xml from "csi/xml";
import { CallMethod } from "csi/xml/CallMethod";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";

/** @property {string} MATERIAL - the node type used in the controller */
const MATERIAL = "Material";

const NewEngineeringChangeOnMSG = declare(New, {

	/**
	 * @override
	 * Allow controller to add parameters to popup view
	 */
	onCreatePopupParams(params): void {
		params.productLabel = MATERIAL;
		params.productStore = this._getMaterialStore();
	},

	/**
	 * Fetch List of all materials under same MSG
	 */
	_getMaterialStore(): StoreNames {
		const rel = lang.mixin(new Relationship(), {
			m_typeNode: MATERIAL,
			m_addPaths: [lang.mixin(new AddPath(), {
				m_path: "Parent:MaterialSecurityGroups",
			})],
			m_url: this.m_urlParent,
		});

		const storeOptions = csiStore.namesOptionsByRelationship(this.getContext(), rel);
		storeOptions.data = [csiStore.nameObject("")];
		storeOptions.action = lang.mixin(new Action(), {
			m_viewRef: lang.mixin(new ViewRef(), {
				m_id: "SecurityGroupMaterials",
				m_url: this.m_urlParent,
			}),
		});
		return new StoreNamesConstructor(storeOptions);
	},

	/**
	 * @override
	 * Material is marked to be taken care on the server side
	 */
	toWriterRequest(fd: FormData): CallMethod {
		const call = this.inherited<CallMethod>(arguments);
		const materialURLs = this.m_formData.getFieldValue(MATERIAL, true);
		call.addParameter("AddURLs", xml.ATTR_REFLIST, materialURLs);
		return call;
	},
});

export = NewEngineeringChangeOnMSG;